import { Box, Card, CardActionArea, CardContent, Typography, alpha, useTheme } from '@mui/material';
import { useTranslate } from 'react-admin';

interface ChannelTypeCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  iconColor?: string;
  onClick: () => void;
  disabled?: boolean;
  comingSoon?: boolean;
}

export const ChannelTypeCard = ({
  title,
  description,
  icon,
  iconColor = '#1976d2',
  onClick,
  disabled = false,
  comingSoon = false,
}: ChannelTypeCardProps) => {
  const translate = useTranslate();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Card
      sx={{
        height: '100%',
        position: 'relative',
        opacity: disabled || comingSoon ? 0.6 : 1,
        transition: 'all 0.2s ease-in-out',
        '&:hover': disabled || comingSoon ? {} : {
          boxShadow: 4,
          transform: 'translateY(-2px)',
          borderColor: 'primary.main',
        },
      }}
      variant="outlined"
    >
      <CardActionArea
        onClick={onClick}
        disabled={disabled || comingSoon}
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          p: 3,
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: alpha(iconColor, 0.1),
            mb: 2,
          }}
        >
          {icon}
        </Box>
        <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
          <Typography
            variant="subtitle1"
            component="h3"
            fontWeight="medium"
            gutterBottom
          >
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
      {comingSoon && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: isDarkMode ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(2px)',
            borderRadius: 1,
          }}
        >
          <Typography variant="subtitle2" fontWeight="medium">
            {translate('resources.channel.comingSoon')}
          </Typography>
        </Box>
      )}
    </Card>
  );
};
